// Generated from SVG to Code Figma Plugin

export const ProductLineMark = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4 6C4 4.34315 5.34315 3 7 3H16.9999C18.656 3 19.9989 4.34368 19.9995 5.99984C20.001 10.8691 19.9988 14.5313 19.9982 19.288C19.998 20.88 18.2284 21.8356 16.8985 20.9605L13.0984 18.4602C12.4312 18.0212 11.5669 18.0212 10.8997 18.4602L7.09932 20.9607C5.76945 21.8357 4 20.8819 4 19.29V6Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
